import { NONBIZ_BASE_URL } from "@constants/api.constants";
import { get } from './api.service';

const endpointNonBiz = NONBIZ_BASE_URL;

export const getMaintenanceInfo = () => {
    return get(`${endpointNonBiz}/maintenance`);
}